/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ex } from './Ex';

class OrderPush extends Ex {
    constructor() {
        super();
        this.baseUrl += '/orderPush';
    }

    batchSyncErpOrder({ ids }) {
        return super.post('/batchSyncErpOrder', { ids }, { timeout: 0, isHandleError: true });
    }

    batchSyncErpOrderTrackingInfo({ ids }) {
        return super.post('/batchSyncErpOrderTrackingInfo', { ids }, { timeout: 0, isHandleError: true });
    }

    pushOrderToGateway({ ids }) {
        return super.post('/pushOrderToGateway', { ids }, { timeout: 0, isHandleError: true });
    }

    batchSyncGatewayOrderTrackingInfo({ ids }) {
        return super.post('/batchSyncGatewayOrderTrackingInfo', { ids }, { timeout: 0, isHandleError: true });
    }

    rePushOrderToWarehousesystem({ id }) {
        return super.post('/rePushOrderToWarehousesystem', { id }, { timeout: 0, isHandleError: true });
    }

    pushOrderToYBG({ ids }) {
        return super.post('/pushOrderToYBG', { ids }, { timeout: 0, isHandleError: true });
    }

    batchSyncYBGOrderTrackingInfo({ ids }) {
        return super.post('/batchSyncYBGOrderTrackingInfo', { ids }, { timeout: 0, isHandleError: true });
    }
}

export default new OrderPush();
export { OrderPush };
